import React from "react";
import S from './AdditionalInformation.module.scss';

export const GazTechnologies = () => {
    return (
        <div className={S.gazTechnologiesStyle}>
            <p className={S.title}>
                I АССОЦИАЦИЯ
            </p>
            <p>
                Ассоциация производителей оборудования «Новые технологии газовой
                отрасли» учреждена в 2012 году при поддержке ПАО «Газпром»
                (свидетельство о государственной регистрации №1137799000723, ИНН
                7710480393).
            </p>
            <p>
                По состоянию на ноябрь 2025 года членами Ассоциации являются 74
                организации.
            </p>
            <p className={S.title}>
                II УПРАВЛЕНИЕ
            </p>
            <p>
                <span>В.А. Зубков</span> - Председатель Наблюдательного совета Ассоциации,
                Председатель Совета директоров ПАО «Газпром».
            </p>
            <p>
                <span>А.Б. Миллер</span> - Президент – Председатель Правления Ассоциации,
                Председатель Правления ПАО «Газпром».
            </p>
            <p className={S.title}>
                III ДЕЯТЕЛЬНОСТЬ
            </p>
            <p>
                Для организации обмена мнениями по актуальным вопросам развития
                газовой отрасли, выработки совместной позиции для обсуждения с
                руководством ПАО «Газпром в рамках Ассоциации сформированы <span>экспертные секции:</span>
            </p>
            <p>
                <li>Газоперекачивающие агрегаты</li>
                <li>Газораспределительное оборудование</li>
                <li>Запорно-регулирующая арматура</li>
                <li>Нефтехимическое оборудование</li>
                <li>Оборудование газопромысловое и буровое</li>
                <li>Газомоторное топливо</li>
                <li>Перспективные материалы и технологии</li>
                <li>Экономическая эффективность</li>
                <li>Техническое регулирование</li>
            </p>
            <p className={S.title}>
                IV СДС ИНТЕРГАЗСЕРТ
            </p>
            <p>
                Приказом ПАО «Газпром» от 24.11.2016 № 751 Ассоциация определена
                Центральным органом Системы добровольной сертификации
                ИНТЕРГАЗСЕРТ по направлению «Технологическое оборудование и
                материалы, энергетическое оборудование, приборы и средства
                автоматизации, вычислительная техника, программные средства».
            </p>
            <p>
                Область деятельности является самой крупной по объему закрепленных
                групп продукции - 60% всего объема МТР, потребляемых ПАО «Газпром»:
                газоперекачивающие агрегаты и двигатели; насосно-компрессорное
                оборудование; нефтехимическое оборудование и трубопроводная арматура;
                газопромысловое и буровое оборудование и др.
            </p>
            <p>
                По направлению Ассоциации в Системе работают 13 органов по
                сертификации, 33 испытательных лаборатории, 2 учебных центра, и более
                103 аттестованных экспертов по сертификации.
            </p>
        </div>
    );
};